"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _download = require("@/utils/download");
var _goodsListActive = require("@/api/operationManagement/goodsListActive");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GoodsDetail',
  components: {},
  data: function data() {
    var validateFile = function validateFile(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error('请上传文件'));
      } else {
        callback();
      }
    };
    return {
      openType: '',
      activityId: '',
      platformCode: '',
      dialogVisible1: false,
      title: '',
      id: '',
      radio: 1,
      ruleForm: {
        fileList: [],
        headPhoto: '',
        type: '',
        goodsId: ''
      },
      typeList: [],
      rules: {
        fileList: [{
          required: true,
          message: '请上传文件',
          validator: validateFile,
          trigger: 'change'
        }],
        type: [{
          required: false,
          message: '请选择类目',
          trigger: 'change'
        }],
        goodsId: [{
          required: true,
          message: '请输入商品Id',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    down: function down() {
      (0, _download.selfDownload)();
    },
    clearPhoto: function clearPhoto() {
      this.ruleForm.headPhoto = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              this.ruleForm.headPhoto = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.radio === 2) {
            if (_this.openType === '1') {
              (0, _goodsListActive.addOnegood)({
                activityId: _this.activityId,
                platformCode: _this.platformCode,
                goodsCategory: _this.ruleForm.type,
                goodsId: _this.ruleForm.goodsId,
                tag: _this.ruleForm.headPhoto
              }).then(function (res) {
                console.log(res);
                if (res.data) {
                  _this.$message({
                    type: 'success',
                    message: '操作成功'
                  });
                  _this.onClose();
                  _this.$emit('insetOk', {
                    type: _this.openType
                  });
                }
              });
            } else if (_this.openType === '2') {
              (0, _goodsListActive.goodsUpdate)({
                id: _this.id,
                goodsCategory: _this.ruleForm.type,
                tag: _this.ruleForm.headPhoto
              }).then(function (res) {
                if (res.data) {
                  _this.$message({
                    type: 'success',
                    message: '操作成功'
                  });
                  _this.onClose();
                  _this.$emit('insetOk', {
                    type: _this.openType
                  });
                }
              });
            } else if (_this.openType === '3') {
              if (_this.ruleForm.headPhoto) {
                _this.$emit('insetOk', {
                  type: _this.openType,
                  url: _this.ruleForm.headPhoto
                });
                _this.onClose();
              } else {
                _this.$confirm('确认要留空标签图片吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this.onClose();
                  _this.$emit('insetOk', {
                    type: _this.openType,
                    url: _this.ruleForm.headPhoto
                  });
                  _this.onClose();
                }).catch(function () {
                  _this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
              }
            }
          } else if (_this.radio === 1) {
            var obj = new FormData();
            obj.append('file', _this.ruleForm.fileList[0].raw);
            obj.append('activityId', _this.activityId);
            console.log(obj);
            (0, _goodsListActive.importGoodsTemplate)(obj).then(function (res) {
              if (res.data) {
                _this.$message({
                  type: 'success',
                  message: '导入成功，请稍后刷新商品列表'
                });
                _this.onClose();
                _this.$emit('insetOk', {
                  type: _this.openType
                });
              } else {
                _this.$message({
                  type: 'error',
                  message: '导入失败，请查看导入结果'
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove: function handleRemove() {
      this.ruleForm.fileList = [];
    },
    change: function change(file, fileList) {
      this.ruleForm.fileList = fileList;
      this.$refs.ruleForm15.validateField('fileList');
    },
    open: function open(val) {
      var _this2 = this;
      console.log(val, '=============');
      this.openType = val.openType;
      this.title = val.title;
      this.typeList = val.typeList;
      if (this.openType === '1') {
        this.radio = 1;
        this.activityId = val.activityId;
        this.platformCode = val.platformCode;
      }
      if (this.openType === '2') {
        this.radio = 2;
        setTimeout(function () {
          _this2.id = val.id;
          _this2.ruleForm.headPhoto = val.tag;
          _this2.ruleForm.type = val.goodsCategory;
          _this2.ruleForm.goodsId = val.goodsId;
        });
      }
      if (this.openType === '3') {
        this.radio = 2;
      }
      this.dialogVisible1 = true;
    },
    onClose: function onClose() {
      this.resetForm('ruleForm15');
      // Object.assign(this.$data, this.$options.data())
      this.dialogVisible1 = false;
      // Object.assign(this.$data, this.$options.data.call(this))
    }
  }
};